$(document).ready(
    function () {
        const p = $("body").attr("p");

        function removeShoppingCartFromHeader() {
            $('#menuLinks').removeClass('shopping-cart-link-visible');
            $('#menuLinks .navbar-nav').addClass('ml-auto');
            $('#shopping-cart-btn').remove();
        }

        if (p === 'shopping_cart') {
            let countDownId = $('#order-multi-count-down-timer');
            let expirationTime = parseInt(countDownId.data("reservation-remaining-time")) * 1000;
            let expirationTimeText = countDownId.data("reservation-time-text");
            let expirationText = countDownId.data("reservation-text");
            let reservationCountDownInterval = null;

            function reservationCountDown(expirationTime, countDownId, expirationText) {
                let remainingTime = expirationTime;
                let reservationExpired = $("#order-multi-count-down-timer").data('reservation-expired');

                let x = setInterval(function () {
                    if (!($('#order-multi-count-down').length > 0)) {
                        clearInterval(x);
                    }

                    remainingTime = remainingTime - 1000;
                    let minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
                    let seconds = ('0' + Math.floor((remainingTime % (1000 * 60)) / 1000)).slice(-2);
                    countDownId.text(expirationText + " " + minutes + ":" + seconds);

                    if (remainingTime <= 0) {
                        clearInterval(x);
                        $.ajax({
                            type: 'GET',
                            url: "/ajax/shopping_cart/cancel_reservation_timeout"
                        })
                            .done(function () {
                                $('#shopping-cart-wrapper').find('.alert:not(.alert-static)').remove();
                                prependAlert('#shopping-cart-wrapper', reservationExpired, 'warning', null);
                                $('#order-multi-count-down').remove();
                                $('.shopping-cart-order').each(function () {
                                    $(this).remove();
                                })
                                $('#order-multi-form-wrapper').remove();
                                removeShoppingCartFromHeader();
                                $('html,body').scrollTop(0);
                            });
                    }
                }, 1000);

                return x;
            }

            reservationCountDownInterval = reservationCountDown(expirationTime, countDownId, expirationText);
        } else if ($('#reservation-multi-alert').length > 0) {
            let reservationAlert = $("#reservation-multi-alert");
            let reservationAlertCountDown = $('#reservation-multi-alert-countdown');
            let reservationExpired = reservationAlert.data('reservation-expired');
            let expirationTimeAlert = parseInt(reservationAlertCountDown.data("remaining-time")) * 1000;
            let reservationCountDownInterval = reservationCountDownAlert(expirationTimeAlert, reservationAlertCountDown);

            function cancelOrderMultiReservation(timeout = true) {
                $.ajax({
                    type: 'GET',
                    url: "/ajax/shopping_cart/cancel_reservation_timeout"
                })
                    .done(function () {
                        if (timeout === true) {
                            reservationAlert.text(reservationExpired);
                            const reservationMultiAlert = $('#reservation-multi-alert');
                            if (reservationMultiAlert.hasClass('d-none')) {
                                reservationMultiAlert.removeClass('d-none');
                            }
                            removeShoppingCartFromHeader();
                        } else if (data.message !== undefined && data.message !== null) {
                            reservationAlert.text(data.message);
                            if (reservationAlert.hasClass('alert-info')) {
                                reservationAlert.removeClass('alert-info');
                                reservationAlert.addClass('alert-warning');
                            }
                        }
                    })
            }

            function reservationCountDownAlert() {
                let remainingTime = expirationTimeAlert;

                let x = setInterval(function () {
                    remainingTime = remainingTime - 1000;
                    let minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
                    let seconds = ('0' + Math.floor((remainingTime % (1000 * 60)) / 1000)).slice(-2);

                    reservationAlertCountDown.text(minutes + ":" + seconds);

                    if (remainingTime <= 0) {
                        clearInterval(x);
                        x = null;
                        cancelOrderMultiReservation();
                    }

                }, 1000);

                return x;
            }

            $(document).on('click', '#cancel-reservation-multi-link', function () {
                e.preventDefault();
                if (reservationCountDownInterval !== null) {
                    clearInterval(reservationCountDownInterval);
                    reservationCountDownInterval = null;
                }
                cancelOrderMultiReservation(false);
            });
        }
    }
);